import { MediaMatcher } from '@angular/cdk/layout';
import { ActivatedRoute } from '@angular/router';
import { Itinerary, Day, PointOfInterest } from './../itineray.model';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { GpxExporterService } from '../gpx-exporter.service';

@Component({
  selector: 'app-customer-itinerary',
  templateUrl: './customer-itinerary.component.html',
  styleUrls: ['./customer-itinerary.component.css']
})
export class CustomerItineraryComponent implements OnInit, OnDestroy {

  mobileQuery: MediaQueryList;

  private mobileQueryListener: () => void;

  itinerary: Itinerary;

  activeDays: Day[] = [];

  constructor(private route: ActivatedRoute, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private gpxExporterService: GpxExporterService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
  }

  ngOnInit() {
    this.itinerary = this.route.snapshot.data.itinerary;
    if (this.route.snapshot.queryParams['day']) {
      const dayIndexes: number[] = this.route.snapshot.queryParams['day'].length ? this.route.snapshot.queryParams['day'] : [this.route.snapshot.queryParams['day']];
      for (const dayIndex of dayIndexes) {
        if (dayIndex < this.itinerary.days.length) {
          this.activeDays.push(this.itinerary.days[dayIndex]);
        } else {
          console.warn("Invalid day index " + dayIndex)
        }
      }
    } else {
      this.activeDays.push(...this.itinerary.days);
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this.mobileQueryListener);
  }

  filterGeneratedPois(pois: PointOfInterest[], generated: boolean) {
    return pois.filter((poi) => generated === true ? poi.generated === true : poi.generated !== true);
  }

  downloadGpx() {

    const gpx = this.gpxExporterService.exportGpx(this.itinerary, this.activeDays);

    const blob = new Blob([gpx], {
      type: 'application/gpx+xml'
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.download = this.itinerary.title + ".gpx";
    a.href = url;
    a.click();
  }

}
